import React from 'react';
import { Link } from 'gatsby';

import { CommentsLink } from './commentslink';
import { slugifyHandle, formatLocaleTime } from '../../utils/common';

export const Excerpt = (props) => {
	const { post, hideComments } = props;
	const dtNow = new Date();
	const dtHeadline = new Date(post.frontmatter.date);
	if (dtHeadline > dtNow) return (<></>);
	const excerpted = !post.html || post.html.indexOf('<!-- end -->') >= 0 || post.timeToRead > 2;
	return (
		<article key={post.id} className='record'>
			<h3><Link to={post.fields.slug}>{post.frontmatter.title}</Link></h3>
			<div className='ledeline'>
				{post.frontmatter.author && <span>By <b><Link to={`/members/${slugifyHandle(post.frontmatter.author)}`}>{post.frontmatter.author}</Link></b></span>}
				<span>{formatLocaleTime(post.frontmatter.date)}</span>
			</div>
			<div dangerouslySetInnerHTML={{ __html: excerpted ? post.excerpt : post.html }} />
			<div className='actionline'>
				{excerpted && <span><b><Link to={`${post.fields.slug}`}>Read on...</Link></b></span>}
				{!hideComments && <CommentsLink post={post} />}
				{hideComments &&
					<span style={{ fontSize: '.9rem' }}>
						<Link to={`${post.fields.slug}#comments`}>Comments</Link>
					</span>
				}
			</div>
		</article>
	);
};
